let defaultMap = {
  'jingxuan': 'ff',
  'qinggan': 'qg',
  'xingge': 'xg',
  'nengli': 'nl',
  'jiankang': 'jk',
  'zhichang': 'zc',
  'renji': 'rj',
  'qinzi': 'qz',
  'quwei': 'qw',
};
let reversMap = {};

for (let key in defaultMap) {
  reversMap[defaultMap[key]] = key;
}

export default defaultMap;

export {
  defaultMap,
  reversMap
}



// WEBPACK FOOTER //
// ./src/util/categoryMap.js